import {
  USER_LOGIN,
  USER_LOGOUT,
  USER_LOGIN_ERROR,
  USER_SIGNUP,
  USER_SIGNUP_ERROR,
  SET_ROOT_LINK,
} from 'actions/actionTypes';
import { IAuthState, UserResponce } from 'types';

type ActionType =
  | { type: 'USER_LOGIN'; payload: UserResponce }
  | { type: 'USER_LOGOUT' }
  | { type: 'USER_SIGNUP'; payload: UserResponce }
  | {
      type: 'SET_ROOT_LINK';
      payload: string;
    }
  | {
      type: 'USER_LOGIN_ERROR';
      payload: Error;
    }
  | { type: 'USER_SIGNUP_ERROR'; payload: Error };

const initialState: IAuthState = {
  user: undefined,
  loginError: {},
  signUpError: {},
  isSignedIn: false,
  newUser: false,
  rootLink: '/process-steps',
};

const user = (state = initialState, action: ActionType): IAuthState => {
  switch (action.type) {
    case USER_LOGIN:
      return {
        ...state,
        user: action.payload,
        isSignedIn: true,
        newUser: false,
      };
    case USER_LOGOUT:
      return {
        ...state,
        user: undefined,
        loginError: {},
        signUpError: {},
        isSignedIn: false,
      };
    case USER_SIGNUP:
      return {
        ...state,
        user: action.payload,
        isSignedIn: true,
        newUser: true,
      };
    case USER_LOGIN_ERROR:
      return {
        ...state,
        loginError: action.payload,
      };
    case USER_SIGNUP_ERROR:
      return {
        ...state,
        signUpError: action.payload,
      };
    case SET_ROOT_LINK:
      return {
        ...state,
        rootLink: action.payload,
      };
    default:
      return state;
  }
};

export default user;
